module.exports = __webpack_public_path__ + "static/media/crowd1.47789d68.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/crowd1.jpeg
// module id = 1192
// module chunks = 0